export function StatusTiles({ tiles, fill, light, onTile, active }) {
  if (!tiles?.length) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3" data-testid="bi-status-tiles">
      {tiles.map((t, i) => (
        <button key={t.key} type="button" onClick={() => onTile?.(t)} disabled={!onTile}
          className={`bi-tile ${light ? "bi-tile-light" : ""} ${active === t.key ? "ring-4 ring-[#e2b85a]" : ""}`}
          style={{ "--bi-fill": fill, animationDelay: `${i * 40}ms` }} data-testid={`bi-tile-${t.key}`}>
          <span className="bi-tile-label">{t.label}</span>
          <span className="bi-tile-value" data-testid={`bi-tile-value-${t.key}`}>{t.value}</span>
          {t.hint && <span className="text-xs opacity-80">{t.hint}</span>}
        </button>))}
    </div>
  );
}
